import TypesService from '../../services/TypesService';
import Card from '../Card';
import ColorPicker from '../ColorPicker';
import Input from '../Input';

import './CardCustomization.scss';

const CardCustomization = ({
	label,
	selectedColor,
	cardNumber = '0000000000000000',
	onLabelChange,
	onColorChange,
	cardholderName = '',
}) => {
	const pickableColors = Object.fromEntries(
		Object.entries(TypesService.CardColors).filter(([key]) => key !== 'transparent')
	);

	return (
		<div className='CardCustomization'>
			<Card
				className='CardCustomization__card'
				color={selectedColor}
				number={cardNumber}
				paymentSystem='mastercard'
				cardholderName={cardholderName}
			/>
			<div className='CardCustomization__label'>
				<Input
					className='CardCustomization__input FormBlock'
					value={label}
					onChange={e => onLabelChange(e.target.value)}
					placeholder={'Enter label'}
				/>
				<p className='CardCustomization__description'>
					You have the option to add a label to the card. Up to 15 characters.
				</p>
			</div>

			<ColorPicker
				className='CardCustomization__picker'
				colors={pickableColors}
				selectedColor={selectedColor}
				onChange={onColorChange}
			/>
		</div>
	);
};

export default CardCustomization;
